
import { Question } from '@/types/assessment';
import { CircularButton } from '@/components/ui/circular-button';
import { Label } from '@/components/ui/label';

interface SingleChoiceQuestionProps {
  question: Question;
  currentValue: string[];
  targetValue: string[];
  onChange: (current: string[], target: string[]) => void;
}

const SingleChoiceQuestion = ({ 
  question, 
  currentValue, 
  targetValue, 
  onChange 
}: SingleChoiceQuestionProps) => {
  const handleCurrentChange = (value: string) => {
    onChange([value], targetValue);
  };
  
  const handleTargetChange = (value: string) => {
    onChange(currentValue, [value]);
  };

  return (
    <div className="grid md:grid-cols-2 gap-8 animate-scale-bounce">
      <div className="assessment-question-card p-6">
        <div className="mb-6 flex items-center gap-3">
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
          <div>
            <h3 className="font-semibold text-green-700">Current State</h3>
            <p className="text-sm text-muted-foreground">Select your current position</p>
          </div>
        </div>
        
        <div className="space-y-4">
          {question.answers.map((answer) => (
            <div key={answer.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 assessment-transition">
              <CircularButton
                isSelected={currentValue.includes(answer.id)}
                variant="current"
                onClick={() => handleCurrentChange(answer.id)}
                size="md"
              />
              <Label 
                className="text-sm font-normal leading-relaxed pt-1 cursor-pointer flex-1" 
                onClick={() => handleCurrentChange(answer.id)}
              >
                {answer.text}
              </Label>
            </div>
          ))}
        </div>
      </div>
      
      <div className="assessment-question-card p-6 bg-gradient-to-br from-primary/5 to-primary/10">
        <div className="mb-6 flex items-center gap-3">
          <div className="w-3 h-3 bg-primary rounded-full"></div>
          <div>
            <h3 className="font-semibold text-gapstars-orange">Target State</h3>
            <p className="text-sm text-muted-foreground">Select your desired future position</p>
          </div>
        </div>
        
        <div className="space-y-4">
          {question.answers.map((answer) => (
            <div key={answer.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-white/50 assessment-transition">
              <CircularButton
                isSelected={targetValue.includes(answer.id)}
                variant="target"
                onClick={() => handleTargetChange(answer.id)}
                size="md"
              />
              <Label 
                className="text-sm font-normal leading-relaxed pt-1 cursor-pointer flex-1" 
                onClick={() => handleTargetChange(answer.id)}
              >
                {answer.text}
              </Label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SingleChoiceQuestion;
